import { useEffect, useState } from "react";
import { getUserById } from "../services/userService";

interface IuseFetchUserById {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  userId: string | number | null | undefined;
}

const useFetchUserById = ({ setIsLoading, userId }: IuseFetchUserById) => {
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    if (!userId) {
      setUserData(null);
      return;
    }

    const fetchUserData = async () => {
      setIsLoading(true);
      try {
        const result = await getUserById(userId);
        setUserData(result);
      } catch (err) {
        console.error("Error fetching user:", err);
        setUserData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [userId, setIsLoading]);

  return [userData, setUserData];
};

export default useFetchUserById;
